import React from 'react'

import { useStoreActions, useStoreState } from 'store'
import Tooltip from 'components/shared/Tooltip'
import infoIcon from 'assets/info.svg'

type MilitaryStatusOption = 'Yes' | 'No'
const options: MilitaryStatusOption[] = ['Yes', 'No']

const tooltipTextBold = 'VA loans'
const tooltipText = 'require self or spouse must be active or retired military.'

export default function MilitaryStatus(props: JSX.IntrinsicAttributes & { className?: string; smallButtons?: string }) {
  const { onInputTracking } = useStoreActions(actions => actions.tracking)
  const { updateDimensions } = useStoreActions(actions => actions.dimensions)
  const { veteranStatus } = useStoreState(state => state.dimensions.dimensions.user)
  const isDesktop = useStoreState(state => state.dimensions.isDesktop)

  const handleChange = (option: MilitaryStatusOption) => {
    updateDimensions({ user: { veteranStatus: option === 'Yes' ? 'RegularMilitary' : 'NoMilitaryService' } })
    onInputTracking({ name: 'formermiltary', label: 'military/veteran', value: option })
  }

  const isChecked = (option: MilitaryStatusOption) => {
    if (option === 'Yes' && veteranStatus === 'RegularMilitary') {
      return true
    } else if (option === 'No' && veteranStatus === 'NoMilitaryService') {
      return true
    }
    return false
  }

  return (
    <div className={`form-element-container sm:mb-2 md:mb-0 ${props.className}`}>
      <label className="FormLabel display-flex justify-content-space-between align-items-baseline">
        Show VA loans
        {isDesktop && (
          <Tooltip
            buttonText=""
            className="text-blue display-inline-block pl-2"
            style={{ fontSize: '14px' }}
            underline={false}
            icon={infoIcon}
            iconAltText="Info"
            arrowPosition={isDesktop ? 'anchorRight' : 'anchorLeft'}
            responsivePosition={true}
          >
            <p className="text-slate type-body-two p-2">
              <span className="font-circular-bold">{tooltipTextBold}</span> {tooltipText}
            </p>
          </Tooltip>
        )}
      </label>
      {!isDesktop && (
        <p className="type-body-two mb-2 text-slate">
          <span className="font-circular-bold">{tooltipTextBold}</span> {tooltipText}
        </p>
      )}
      <div
        className={`FormButtonGroup FormButtonGroup--fill ${props.smallButtons} sm:mb-8 md:mb-0`}
        onClick={e => e.stopPropagation()}
        data-testid="veteranStatus"
      >
        {options.map(label => (
          <span key={label} className="FormButtonGroup-button">
            <input
              className="FormButtonGroup-input"
              type="checkbox"
              data-testid={`checkbox-veteranStatus-${label}`}
              id={`checkbox-veteranStatus-${label}`}
              // If a user lands on the page with a pre-existing URL with a value other than zero, automatically select Yes
              checked={isChecked(label)}
              onChange={() => handleChange(label)}
            />
            <label
              data-testid={`veteranStatus-${label}`}
              className="type-body-two FormButtonGroup-label"
              htmlFor={`checkbox-veteranStatus-${label}`}
            >
              {label}
            </label>
          </span>
        ))}
      </div>
    </div>
  )
}
